import { AudienceFlagsRender, FlagsModuleData } from '../components';
import { createWorkflowUpdatesChangeExtension } from './workflow-updates-change';

const describeFlagsChanges = (change: {
  oldValue?: unknown;
  newValue?: unknown;
}): string[] => {
  const oldValue = change.oldValue as FlagsModuleData | null;
  const newValue = change.newValue as FlagsModuleData | null;
  const changes: string[] = [];

  if (oldValue?.targetingKeySelector !== newValue?.targetingKeySelector) {
    changes.push('randomization unit');
  }
  if (
    (oldValue?.stickyAssignments ?? false) !==
    (newValue?.stickyAssignments ?? false)
  ) {
    changes.push('sticky assignments');
  }
  if (
    (oldValue?.ignoreTargetingForSticky ?? false) !==
    (newValue?.ignoreTargetingForSticky ?? false)
  ) {
    changes.push('inclusion criteria enforcement');
  }

  return changes;
};

export const AUDIENCE_FLAGS_CHANGE_EXTENSION =
  createWorkflowUpdatesChangeExtension({
    id: 'audience-flags-change',
    priority: 1,
    predicate: ({ change }) =>
      change.fieldPath === '/module_data/flags' &&
      describeFlagsChanges(change).length > 0,
    title: change => {
      const changes = describeFlagsChanges(change);
      if (changes.length === 1) return `Updated ${changes[0]}`;
      return 'Updated audience configuration';
    },
    render: AudienceFlagsRender,
  });
